import {
    GET_ADMIN_PINS_SUCCESS,
    OPEN_BANNER_MODAL,
    CLOSE_BANNER_MODAL,
    GET_ALL_TRANSACTIONS_SUCCESS,
    CLEAR_ADMIN_PINS,
    ANALYTICS_DISABLE_TOGGLE_SUCCESS,
    TOGGLE_UNLIMITED_PINS_SUCCESS
} from '../Actions/admin';

const DEFAULT_STATE = {
    savingDatatypes: false,
    datatypes: {},
    fetchingAllUsers: false,
    users: [],
    pins: [],
    isMorePages: false,
    transactions: [],
    deactivatingUser: false,
    activatingUser: false,
    isBannerModalOpen: false,
    bannerIndex: 0,
    bannerType: ''
};

export default function(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case 'SAVE_DATATYPES_REQUEST':
            return {...state, savingDatatypes: true};
        case 'SAVE_DATATYPES_SUCCESS':
            return {...state, datatypes: action.datatypes, savingDatatypes: false};
        case 'SAVE_DATATYPES_FAILURE':
            return {...state, savingDatatypes: false};
        case 'GET_ALL_USERS_REQUEST':
            return {...state, fetchingAllUsers: true};
        case 'GET_ALL_USERS_SUCCESS':
            return {
                ...state,
                users: action.data.users,
                isMorePages: action.data.isMorePages,
                fetchingAllUsers: false,
                pins: []
            };
        case GET_ALL_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactions: action.data.transactions,
                isMorePages: action.data.isMorePages,
            };
        case 'GET_ALL_USERS_FAILURE':
            return {...state, fetchingAllUsers: false};
        case 'DEACTIVATE_REQUEST':
            return {...state, deactivatingUser: true};
        case 'DEACTIVATE_SUCCESS':
            return {...state, deactivatingUser: false};
        case 'DEACTIVATE_FAILURE':
            return {...state, deactivatingUser: false};
        case 'ACTIVATE_REQUEST':
            return {...state, activatingUser: true};
        case 'ACTIVATE_SUCCESS':
            return {...state, activatingUser: false};
        case 'ACTIVATE_FAILURE':
            return {...state, activatingUser: false};
        case GET_ADMIN_PINS_SUCCESS:
            return {
                ...state,
                pins: action.response.data.pins,
                isMorePages: action.response.data.isMorePages,
                users: []
            }; // resetting users to ease up in case of big numbers until pagination will be build in
        case CLEAR_ADMIN_PINS:
            return {
                ...state,
                pins: [],
                isMorePages: false,
                users: []
            }
        case OPEN_BANNER_MODAL:
            return {...state, isBannerModalOpen: true, bannerIndex: action.bannerIndex, bannerType: action.bannerType};
        case CLOSE_BANNER_MODAL:
            return {...state, isBannerModalOpen: false, bannerIndex: null, bannerType: null};
        case ANALYTICS_DISABLE_TOGGLE_SUCCESS:
            state.users.find(u => {
                if (u._id === action.userId) {
                    u.isAnalyticsDisabled = action.isAnalyticsDisabled
                    return true
                }

                return false
            });

            return {
                ...state,
                users: [ ...state.users ]
            }
        case TOGGLE_UNLIMITED_PINS_SUCCESS:
            state.users.find(u => {
                if (u._id === action.userId) {
                    u.isUnlimitedPins = action.isUnlimitedPins
                    return true
                }

                return false
            });

            return {
                ...state,
                users: [ ...state.users ]
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/admin.js